import { Base } from "ui/Scripts/source/framework/base";
import { IRecordFurtherEducationGroupNode, RecordFurtherEducationGroupNode } from "ui/Scripts/source/models/recordFurtherEducationGroup/recordFurtherEducationGroupNode";
import { IRecordListItemUserFurtherEducation, RecordListItemUserFurtherEducation } from "ui/Scripts/source/models/recordUserFurtherEducation/recordListItemUserFurtherEducation";
import { IRecordListItemUserQualification, RecordListItemUserQualification } from "ui/Scripts/source/models/recordUserQualification/recordListItemUserQualification";

export interface IUserFurtherEducationList {
    hasMore: boolean;
    page: number;
    sortColumn: string;
    items: IRecordListItemUserFurtherEducation[];
    qualifications: IRecordListItemUserQualification[];
    furtherEducationGroups: IRecordFurtherEducationGroupNode[];
}

export class UserFurtherEducationList implements IUserFurtherEducationList {
    hasMore: boolean;
    page: number;
    sortColumn: string;
    items: RecordListItemUserFurtherEducation[];
    qualifications: RecordListItemUserQualification[];
    furtherEducationGroups: RecordFurtherEducationGroupNode[];

    constructor();
    constructor(obj: IUserFurtherEducationList);
    constructor(obj?: any) {
        this.hasMore = obj && obj.hasMore || false;
        this.page = obj && obj.page || 1;
        this.sortColumn = obj && obj.sortColumn || "";
        this.items = Base.getTypedArray(obj ? obj.items : null, RecordListItemUserFurtherEducation);
        this.qualifications = Base.getTypedArray(obj ? obj.qualifications : null, RecordListItemUserQualification);
        this.furtherEducationGroups = Base.getTypedArray(obj ? obj.furtherEducationGroups : null, RecordFurtherEducationGroupNode);
        for (const qualification of this.qualifications) {
            RecordListItemUserQualification.setCodeAndValidity(qualification, this.furtherEducationGroups, this.items);
        }
    }
}